<template>
    <div>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }" tag="form" class="sa-custom-form" >
              <h1 class="sa-h-sm-up">Sign In</h1>
                <ValidationProvider name="organization" rules="required" v-slot="{ errors }" tag="div" class="sa-form-group">
                  <label class="sa-floating">Organization Name</label>
                  <i class="icon-organization sa-h-sm-up"></i>
                  <v-select id="organization" name="organization" :options="options" label='title' :reduce="title => title.value" v-model="loginForm.orgt"><span slot="no-options">No data</span></v-select>
                  <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider name="access Id" rules="required" v-slot="{ errors }" tag="div" class="sa-form-group" v-if="loginForm.orgt == 'H'">
                  <label class="sa-floating">Access Id</label>
                  <i class="icon-id-card2 sa-h-sm-up"></i>
                    <input type="text" id="accessId" name="access Id" class="sa-form-control" v-model="loginForm.acc_id"
                      @input="loginForm.acc_id = loginForm.acc_id.toUpperCase().trim()" />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider name="email Id" rules="required|email" v-slot="{ errors }" tag="div" class="sa-form-group" v-if="loginForm.orgt == 'H'">
                  <label class="sa-floating">Email</label>
                  <i class="icon-envelope sa-h-sm-up"></i>
                    <input type="text" id="emailId" name="email Id" class="sa-form-control" v-model="loginForm.email" />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider name="country" rules="required" v-slot="{ errors }" tag="div" class="sa-form-group" v-if="loginForm.orgt == 'S'">
                  <label class="sa-floating">Select Country</label>
                  <i class="icon-flag sa-h-sm-up"></i>
                    <v-select id="country" name="country" :options="countryList" label='title' :reduce="title => title.value" v-model="loginForm.san_off"><span slot="no-options">No data</span></v-select>
                    <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="sa-row" v-if="loginForm.orgt == 'S'">
                  <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                    <ValidationProvider name="country code" rules="required|numeric" v-slot="{ errors }" tag="div" class="sa-form-group">
                      <label class="sa-floating">Code</label>
                      <i class="icon-flag sa-h-sm-up"></i>
                      <v-select id="countryCode" name="country code" :options="phoneCodes" :reduce="title => (title.countryAreaCode).toString()" v-model="loginForm.pc" label="nameCode">
			                  <template slot="option" slot-scope="option">
                          {{ option.countryName }} +{{option.countryAreaCode}}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          +{{option.countryAreaCode}}
                        </template>
                        <span slot="no-options">No data</span>
                      </v-select>
                        <span class="sa-val-err">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="sa-col-xs6 sa-col-sm8 sa-col-md8 sa-col-lg8">
                    <ValidationProvider name="phone number" rules="required|numeric" v-slot="{ errors }" tag="div" class="sa-form-group">
                      <label class="sa-floating">Phone Number</label>
                      <i class="icon-mobile sa-h-sm-up"></i>
                        <input @keyup.enter="handleSubmit(login)" type="number" id="phoneNumber" name="phone number" class="sa-form-control" v-model="loginForm.ph" />
                        <span class="sa-val-err">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <ValidationProvider name="password" rules="required" v-slot="{ errors }" tag="div" class="sa-form-group">
                  <label class="sa-floating">Password</label>
                  <i  class="icon-lock sa-h-sm-up"></i>
                  <i @click="showPassword()" class="icon-invisible icon-dir" v-if="visibility == 'password'"></i>
                  <i @click="hidePassword()" class="icon-eye icon-dir" v-if="visibility == 'text'"></i>
                    <input @keyup.enter="handleSubmit(login)" :type="visibility" class="sa-form-control" v-model="loginForm.pw" name="password" id="password" />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="sa-form-group sa-text-right">
                  <a href="#" class="sa-text-underline" @click="forgotPas">Forgot
                    password?</a>
                </div>
                <div class="sa-form-group sa-mb0">
                  <button type="button" class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-signup-btn"
                    @click="handleSubmit(login)">Sign In
                    <img src="../../assets/img/loader-white.svg" alt="loader" class="sa-sign-loader" v-if="loader" /></button>
                </div>
                <!-- <div class="sa-or">
                  <span class="sa-or-label">Or</span>
                </div>
                <div class="sa-social">
                  <router-link to="/" class="sa-social-fb">Facebook</router-link>
                  <router-link to="/" class="sa-social-google">Google</router-link>
                </div> -->
                <div class="sa-h-sm-up sa-mob-signin">
                  <span>Don’t have an account?</span>
                  <a @click="$emit('show-signup')" v-bind:class="[ tabSelection === 'signup' ? 'active' : '' ]">Sign Up</a>
                </div>
            </ValidationObserver>
    </div>
</template>
<script>
  import { pro_url, auth_url } from "../../../config/endpoints"
  import { oh_url, com_url } from "../../../config/endpoints"
  import { extend } from 'vee-validate';
  import { notificationSetup } from '../../util/notifications'
import { bus } from '../../main';
import { LOGIN } from '../../util/constants';
export default {
    data() {
      return {
          forgotPasDial: false,
          enterPhDial: false,
          getOTPSmsDial: false,
          countryList: [],
          phoneCodes: [],
          visibility: 'password',
          loader: false,
          options: [{"value":"S","title":"Sanar"},{"value":"H","title":"Hospital"}],
          tabSelection: 'login',
          loginForm: {
          pc: "966",
          ph: "",
          pw: "",
          orgt: "S",
          san_off: ""
        }
      }
    },
    mounted() {
      let _self = this
      _self.getCountryList()
      _self.getPhoneCodes()
       let coun = this.phoneCodes;
       this.loginForm.pc = coun == "SA" ? "966" : coun == "IN" ? "91" : "966"
       this.coun = this.loginForm.pc
    },
     watch: {
      'loginForm.orgt' : {
        immediate: true,
        handler (val) {
          this.loginForm = { orgt: val }
        }
      },
      'loginForm.san_off': {
        immediate: true,
         handler (val) {
          if(val == 'SA'){
            this.loginForm.pc = '966'
          }else if(val == 'IN'){
            this.loginForm.pc = '91'
          }else if(val == 'JO'){
            this.loginForm.pc = '962'
          }
        }
      }
    },
     methods: {
          getPhoneCodes() {
        let _self = this
        _self.$store.dispatch('httpPost', {
          uri: `${oh_url}/general/getStaticData`,
          body: { mtype: ["code"] }
        }).then(response => {
          if (response.status = 1000) {
            _self.phoneCodes = response.data.code
            if (_self.phoneCodes && _self.phoneCodes.length) {
              _self.phoneCodes.map((pc)=>{
                pc.nameCode = pc.countryName + '+' + pc.countryAreaCode 
              })
            }
          }
        }).catch(e => {
        })
      },
       showPassword() {
            this.visibility = 'text';
        },
        hidePassword() {
            this.visibility = 'password';
        },
        //   get list of countries/office ids
      getCountryList() {
        let _self = this
        _self.$store.dispatch('httpGet', {
          uri: `${pro_url}/countryList`
        }).then(response => {
          if (response.status = 1000) {
            _self.countryList = response.data
          }
        }).catch(e => {
        //console.log(e)
        })
      },
         forgotPas() {
        this.$parent.forgotPasDial = true;
        let coun = this.$parent.phoneCodes;
        let counforget = this.$parent.phoneCodes;
        this.$parent.forgetPassword.phonecode = this.loginForm.pc
        this.counforget = this.$parent.forgetPassword.phonecode
        this.$parent.enterPhDial = true
      },
      // request for login
      login() {
        let _self = this
        _self.loader = true
        _self.$store.dispatch('httpPost', {
          uri: `${auth_url}/pro/login`,
          body: _self.loginForm
        }).then(response => {
          if (response.status == 1000) {
            console.log('HELLO');
            _self.$localStorage.set("token", response.data.token, 60 * 60 * 2 + 55)
            _self.$localStorage.set("utid", response.data.userData.utid)
            _self.$localStorage.set("userdata", JSON.stringify(response.data.userData), 60 * 60 * 2 + 55)
            _self.$router.push({ path: '/dashboard' })
            _self.$store.dispatch("SET_USER", response.data.userData)
            _self.$store.dispatch("SET_NAVIGATE", true);
            console.log('REDIRECT');
            _self.$store
              .dispatch("httpGet", {
                uri: `${oh_url}/pro/notification/count`,
              })
              .then((response) => {
                if (response && response.status === 1000 && response.data) {
                      _self.$store.dispatch('SET_NOTIFICATION_COUNT', response.data.count || 0)
                }
              });
            // emmiting login event.
            bus.$emit(LOGIN)
          } else {
            // _self.$refs.form.setErrors({
            //     'email Id': [response.error],
            //     'phone number': [response.error],
            //     'country code': [response.error],
            //     'password': [response.error]
            // });
            _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.error, class: 'sa-a-danger'})
          }
          _self.loader = false
        }).catch(e => {
         // console.log(e)
        });
      }
     }
}
</script>